<template>
  <div class="register-form">
    <b-alert variant="danger" :show="hasSubmitError" dismissible>
      {{submitErrorMessage}}
    </b-alert>

    <b-form novalidate @submit.stop.prevent="register">

      <b-form-row>
        <b-col>
          <b-form-group
            id="first-name-input-group"
            :label="$t('register.firstNameLabel')"
            label-for="first-name-input"
          >
            <b-form-input
              autocomplete="off"
              type="text"
              id="first-name-input"
              name="first-name"
              v-model="firstName"
              v-validate="{required: true}"
              :state="validateState('first-name')"
            ></b-form-input>

            <b-form-invalid-feedback>
              {{$t('register.firstNameInvalid')}}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="last-name-input-group"
            :label="$t('register.lastNameLabel')"
            label-for="last-name-input"
          >
            <b-form-input
              autocomplete="off"
              type="text"
              id="last-name-input"
              name="last-name"
              v-model="lastName"
              v-validate="{required: true}"
              :state="validateState('last-name')"
            ></b-form-input>

            <b-form-invalid-feedback>
              {{$t('register.lastNameInvalid')}}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-group
        id="phone-number-input-group"
        :label="$t('register.phoneNumberLabel')"
        label-for="phone-number-input"
      >
        <b-form-input
          autocomplete="off"
          type="text"
          id="phone-number-input"
          name="phone"
          v-model="phoneNumber"
          v-validate="{required: false}"
          :state="validateState('phone')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('register.phoneNumberInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="email-input-group"
        :label="$t('register.emailLabel')"
        label-for="email-input"
      >
        <b-form-input
          autocomplete="off"
          type="email"
          id="email-input"
          name="email"
          v-model="email"
          v-validate="{required: true, email: true}"
          :state="validateState('email')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('register.emailInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="password-input-group"
        :label="$t('register.passwordLabel')"
        label-for="password-input"
      >
        <b-form-input
          autocomplete="off"
          type="password"
          id="password-input"
          ref="password"
          name="password"
          v-model="password"
          v-validate="{required: true, min: 6}"
          :state="validateState('password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('register.passwordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="confirm-password-input-group"
        :label="$t('register.passwordInvalid')"
        label-for="confirm-password-input"
      >
        <b-form-input
          autocomplete="off"
          type="password"
          id="confirm-password-input"
          name="confirm-password"
          v-model="confirmPassword"
          v-validate="{required: true, confirmed: 'password'}"
          :state="validateState('confirm-password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('register.confirmPasswordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-col>
          <loading-button
            :text="$t('register.btnText')"
            :loading-text="$t('register.btnLoadingText')"
            variant="primary"
            :loading=submitting
            type="submit"
            :disabled="veeErrors.any()"
          />
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col>
          <p>
            {{$t('register.alreadyAccount')}}
            <router-link to="/login">{{$t('register.clickHere')}}</router-link>
            {{$t('register.toLogin')}}
          </p>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import FormValidation from '../../mixins/FormValidation';

  export default {
    mixins: [FormValidation],
    data() {
      return {
        submitting: false,
        email: '',
        phoneNumber: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        hasSubmitError: false,
        submitErrorMessage: '',
      };
    },
    methods: {
      register() {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          this.submitting = true;
          this.$store.dispatch('account/register', {
            email: this.email,
            phoneNumber: this.phoneNumber,
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
          }).then(() => {
            this.$toasted.success(this.$t('register.welcomeMessage', { name: this.firstName }), {
              icon: 'heart',
            });
            this.$router.push('/');
          }).catch((err) => {
            if (err.response.status === 400) {
              this.submitErrorMessage = err.response.data.message;
            } else {
              this.submitErrorMessage = this.$t('register.errorMessage');
            }
            this.hasSubmitError = true;
          }).finally(() => {
            this.submitting = false;
          });
        });
      },
    },
  };
</script>
